import { getHostname } from "@punchup/utils/hostname";

const hostname = getHostname();

export const STATSIG_SDK_PROXY_URL = `${hostname}/ssig-sdk/`;
export const STATSIG_EVENT_LOGGING_API_PROXY_URL = `${hostname}/ssig-events/`;
